import { MailRowDataPropertyGetter, TableView } from 'owa-mail-list-store';

/**
 * Get all item ids for the rowKeys
 * @param rowKeys array of rowKeys to convert
 * @param tableView the table view
 * @return an array of all item id strings from the specified rowKeys
 */
export default function getItemidsFromMessages(rowKeys: string[], tableView: TableView): string[] {
    const allItemIds: { [id: string]: boolean } = {};

    rowKeys.forEach(rowKey => {
        const itemId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView).Id;

        // In case of multi-value sorts there can be two rows with same itemId
        // Hence we have to dedup the ids
        if (!allItemIds[itemId]) {
            allItemIds[itemId] = true;
        }
    });

    return Object.keys(allItemIds);
}
